import { Box, ProgressCircle, useAlert } from "@prismicio/editor-ui"
import { useMutation } from "@tanstack/react-query"
import { useEffect, useRef } from "react"

import { useRouteParams } from "../../app/routing"
import { createPortalSession, Intent } from "../../app/services/billing"

export function StripeCustomerPortalRedirectPage() {
  const { showAlert } = useAlert()
  const hasOpenedRef = useRef(false)

  const {
    search: { intent },
  } = useRouteParams({
    search: {
      intent: Intent,
    },
  })

  const { mutate: openPortal, isPending } = useMutation({
    mutationFn: () => createPortalSession(intent),
    onError: () => {
      showAlert({
        title: "Error",
        subtitle: `Failed to open ${intentToTitle[intent]}.`,
      })
    },
    onSuccess: ({ url }) => {
      window.location.href = url
    },
  })

  useEffect(() => {
    if (!hasOpenedRef.current) {
      hasOpenedRef.current = true
      void openPortal()
    }
  }, [openPortal])

  return isPending ? <FullPageLoadingSpinner /> : null
}

const intentToTitle: Record<Intent, string> = {
  invoices_view: "Payment History",
}

function FullPageLoadingSpinner() {
  return (
    <Box
      display="flex"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <ProgressCircle color="purple9" />
    </Box>
  )
}
